const CreditCell = ({value, title, width, dataId}:{value: string, title:string, width: number,  dataId: string}) => {
  return (
    <div className='border-2 m-2 border px-3 py-2'  data-id={dataId} style={{width: `${width}px`, borderRadius: '8px', height: '70px'}}>
        <div className='fs-3 fw-bold'>{value ?? 0}</div>
        <div className='fs-4'>{title}</div>
    </div>)
}

export default CreditCell 